import {Component, Input, OnInit} from '@angular/core';
import {User} from "../../../../../user/user";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import successPoints from "./hosted-trial-points.json";
import {UserSubscription} from "../../../../../user/user-subscription";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {DashboardUtils} from "../../../../../shared/utils/dashboard-utils";
import {Website} from "../../../../../websites/website/website";
import {Router} from "@angular/router";

@Component({
    selector: 'db-hosted-trial-started',
    templateUrl: './hosted-trial-started.component.html',
    styleUrls: ['./hosted-trial-started.component.scss'],
    standalone: false
})
export class HostedTrialStartedComponent implements OnInit {

  @Input() user: User;
  @Input() website: Website;
  @Input() subHeader: string;
  @Input() icon: boolean;
  @Input() flow?: string;
  @Input() userSubscription: UserSubscription;

  points;
  isMobile = false;
  loadingMagicLink: boolean;
  lottieConfig: any;


  constructor(
    private readonly _activeModal: DbActiveModal,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _router: Router
  ) {
  }

  ngOnInit() {
    this.lottieConfig = {
      path: 'assets/images/lotties/success-lottie.json',
      renderer: 'svg',
      autoplay: true,
      loop: true
    };
    this.isMobile = window.innerWidth <= 768;
    const websiteCount = this.userSubscription?.plan?.hostingService?.domain_count?.parameter_value;
    const aiCredits = this.userSubscription?.plan?.aiAssistantService?.ai_trial_limitation?.parameter_value;
    this.points = this.website?.isEcommerceWebsite ? successPoints['ecommerce'] : successPoints['basic'];
    for (let i = 0; i < this.points.length; i++) {
      this.points[i] = this.points[i]
        .replace("{{website}}", websiteCount)
        .replace("{{AiCredits}}", aiCredits);
    }
  }

  proceed() {
    let action;
    let label;
    if (this.icon) {
      action = 'Section-based AI Flow - Preview and Edit';
      label = this.flow;
    }
    else {
      action = 'Proceed button';
      label = 'blank';
    }
    this._activeModal.close();
  }
}
